<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-group g-main-wrapper">
      <p-detail-filter
        ref="filter"
        :media-data="mediaData"
        :advert-position-original-data="AdvertPositionOriginalData"
        :agentData="agentData"
        :selectList="selectList"
        @on-change="filterSaveData"
        @on-search="searchFilterData"
      />
      <div class="c-control">
        <el-form class="operate-btns" label-width="0" inline>
          <el-form-item>
            <el-dropdown @command="batchActions" trigger="click">
              <el-button>
                批量操作
                <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="isHasAddWhite" :command="1">批量添加白名单</el-dropdown-item>
                <el-dropdown-item v-if="isHasCancleWhite" :command="2">批量取消白名单</el-dropdown-item>
                <el-dropdown-item v-if="isHasBachOpen" :command="3">批量启用</el-dropdown-item>
                <el-dropdown-item v-if="isHasBatchCancle" :command="4">批量禁用</el-dropdown-item>
                <el-dropdown-item v-if="isHasBatchCancle" :command="5">联调/数据同步</el-dropdown-item>
                <el-dropdown-item :command="7">批量更新头条账号头像</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="batchActions(6)">账号充值/转账</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="isHasFinanceAlert" type="primary" @click="openFinaceModal">财务任务告警</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="isHasNewJob" type="primary" @click="newJob">新建任务</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="downAdSpiderDataList">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-if="hasMonthSync" :disabled="!selectList.length" @click="syncMonthData">同步月消耗</el-button>
          </el-form-item>
          <el-form-item class="g-pull-right">
            <el-button @click="modalColumn = true">自定义列</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog :visible.sync="newJobModal" width="420px" title="新建任务">
        <div class="">
          <el-form label-width="80px" inline>
            <el-form-item label="媒体">
              <el-select
                v-model="modalMedia"
                collapse-tags
                filterable
                clearable
                placeholder="请选择媒体"
                style="width: 100%"
                :popper-append-to-body="false"
                @change="handleMediaSelect"
              >
                <el-option v-for="item in spiderMediaData" :key="item.mediaId" :value="item.mediaId" :label="item.mediaName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账号">
              <el-select
                v-model="modalAccount"
                collapse-tags
                filterable
                clearable
                placeholder="请选择账号"
                style="width: 100%"
                :popper-append-to-body="false"
                @change="handleAccountSelect"
              >
                <el-option v-for="item in accountData" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelNewJob">取消</el-button>
          <el-button type="primary" @click="confirmNewJob">确定</el-button>
        </span>
      </el-dialog>

      <!-- 同步月消耗 -->
      <el-dialog :visible.sync="monthDataSyncForm.modal" title="同步月消耗" width="420px" custom-class="sync-form-modal">
        <div class="sync-form">
          <el-form label-width="80px">
            <el-form-item label="所选账号"> 共选择{{ selectList.length }}个账号 </el-form-item>
            <el-form-item label="所选月份">
              <el-date-picker
                style="width: 100%"
                v-model="monthDataSyncForm.month"
                :picker-options="{ disabledDate: (date) => date && date.valueOf() > Date.now() }"
                type="month"
                placeholder="选择月"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="失败信息" v-if="monthDataSyncForm.errorTxtList.length">
              <div class="error-info">
                <p v-for="(txt, idx) in monthDataSyncForm.errorTxtList" :key="idx">{{ txt }}</p>
              </div>

              <div class="result-num" v-if="monthDataSyncForm.fetched">
                <span>成功：{{ monthDataSyncForm.successNum }}条；</span>
                <span>失败：{{ monthDataSyncForm.errorNum }}条；</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelMonthSync">取消</el-button>
          <el-button type="primary" v-if="!monthDataSyncForm.fetched" :loading="monthDataSyncForm.loading" @click="confirmMonthSync">
            确定
          </el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="financeModal" width="510px" title="财务任务状况报警">
        <div class="ghost-button-styles">
          <el-form label-width="140px">
            <el-form-item label="报警时间">
              <span style="display: block; color: #ff6400">每月月初和月末提醒</span>
            </el-form-item>
            <el-form-item label="规则">
              <span style="display: block; color: #ff6400">启用的账号，同步任务失败或者未开始进行提醒</span>
            </el-form-item>
            <el-form-item label="告警">
              <el-switch v-model="alarmStatus" :active-value="1" :inactive-value="0" @change="changeActive" />
            </el-form-item>
            <el-form-item v-if="!finaceAlertUserStatus">
              <el-radio-group v-model="alarm">
                <el-radio-button ghost label="1" :disabled="label1">钉钉</el-radio-button>
                <el-radio-button ghost label="2" :disabled="label2">邮件</el-radio-button>
                <el-radio-button ghost label="3" :disabled="label3">钉钉+邮件</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="告警人员选择" v-if="!finaceAlertUserStatus">
              <el-select
                v-model="finaceAlertUser"
                multiple
                collapse-tags
                filterable
                clearable
                :disabled="finaceAlertUserStatus"
                placeholder="请选择人员"
                style="width: 100%; overflow: hidden"
              >
                <el-option v-for="item in finaceOperatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelFinanceAlarm">取消</el-button>
          <el-button type="primary" @click="confirmFinanceAlarm">确定</el-button>
        </span>
      </el-dialog>
      <!-- 表格列表 -->
      <Viewport v-model="tableHeight">
        <TaskSyncTable
          ref="tableRef"
          :height="tableHeight"
          :value="spining"
          :data="jobList"
          :columns="tableCol"
          v-bind:sumdata="sumdata"
          @on-sort="sortTable"
          @on-refresh="getData"
          @header-dragend="headerDragend"
          @on-select="setSelectList"
        ></TaskSyncTable>
        <div class="pager">
          <el-pagination
            :total="total"
            :current-page.sync="pageIndex"
            :page-size.sync="pageSize"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="changePageIndex"
            @size-change="changePageSize"
            background
          />
        </div>
      </Viewport>

      <!-- 自定义列 -->
      <custom-column
        ref="tableCustomColsRef"
        v-model="modalColumn"
        name="sycjobCustomColumn"
        :data="rawTableCols"
        :sub-title="['计划数据', '报表数据', '其他', '任务数据']"
        @on-select="onTableColsChange"
      />
    </div>
  </Layout>
</template>
<script>
import moment from 'moment'
import mixin from './mixin'
import { isArray, timeout, isEmpty } from '@/common/js/utils'
import { datetimeToSec } from '@/common/js/filters'
import PDetailFilter from './components/filter.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import TaskSyncTable from './components/table-idea.vue'
import { adAccount, getSpiderMedia, getSysMember, queryAgentList } from '@/api/common.model'
import { addAdSpiderJob, financeEmailAlertSet, getJobList, getFinanceEmailAlert, batchMonthSyndata, div } from '@/api/ptom.data.model'

import { GROUP_TOUTIAO } from '../data/tableTitle'
import { HOST_API } from '@/api/config'
import { getLocal } from '@/common/js/api'
const makeSyncFormItem = () => {
  return {
    month: moment().subtract(1, 'months').format('YYYY-MM'),
    modal: false,
    loading: false,
    errorTxtList: [],
    fetched: false,
    successNum: 0,
    errorNum: 0
  }
}
export default {
  name: 'jobList',
  mixins: [mixin],
  components: { PDetailFilter, CustomColumn, TaskSyncTable },
  computed: {
    // 存local用户自定义列
    custom() {
      return 'sycjob'
    },
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    },
    open() {
      return '同步任务管理'
    },
    isHasFinanceAlert() {
      return this.access.includes('M20893')
    },
    isHasNewJob() {
      return this.access.includes('M20894')
    },
    isHasAddWhite() {
      return this.access.includes('M20896')
    },
    hasMonthSync() {
      return this.access.includes('M21014')
    },
    isHasCancleWhite() {
      return this.access.includes('M20897')
    },
    isHasBachOpen() {
      return this.access.includes('M20898')
    },
    isHasBatchCancle() {
      return this.access.includes('M20899')
    }
  },
  methods: {
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    setSelectList(val) {
      this.selectList = val
    },
    /**
     * @description: 打开同步月数据表单弹窗
     */
    syncMonthData() {
      this.monthDataSyncForm.modal = true
    },
    cancelMonthSync() {
      this.monthDataSyncForm = makeSyncFormItem()
    },
    confirmMonthSync() {
      const { month } = this.monthDataSyncForm
      if (!month) return this.$Message.warning('请选择月份')
      this.monthDataSyncForm.loading = true
      const isCurrMonth = moment(month).format('YYYY-MM') === moment().format('YYYY-MM')

      // 如果是当月传入1号到当天，如果是其他月份传1号到月的最后一天
      const params = {
        taskIds: this.selectList.map((s) => s.taskId),
        synBeginTime: moment(month).format('YYYY-MM-01'),
        synEndTime: (isCurrMonth ? moment() : moment(month).endOf('month')).format('YYYY-MM-DD')
      }
      batchMonthSyndata(params).then((data) => {
        const { successNum, errorNum, msg, result } = data
        if (result) {
          this.$Message.info('同步成功，两秒后自动关闭')
          setTimeout(() => {
            this.cancelMonthSync()
          }, 2000)
        } else {
          this.monthDataSyncForm.errorTxtList = msg.split(',')
          this.monthDataSyncForm.successNum = successNum
          this.monthDataSyncForm.errorNum = errorNum
          this.monthDataSyncForm.loading = false
        }
        this.monthDataSyncForm.fetched = true

        if (successNum > 0) {
          this.$refs.filter.sendEvent()
        }
      })
    },
    downAdSpiderDataList() {
      const len = this.selectList.length
      const easySelectList = Object.assign([], this.app)
      if (len !== 0) {
        for (var i = 0; i < len; i++) {
          easySelectList.push(this.selectList[i].accountId)
        }
      }

      const {
        mediaId,
        accountId,
        opId,
        dataModel,
        taskStatus,
        accountStatus,
        accountType,
        projectGroupOpId,
        whiteList,
        keyword,
        order,
        agentId,
        sort
      } = this.params
      const urlParams = new URLSearchParams()
      urlParams.append('sessionid', this.$store.state.token)

      if (mediaId) {
        urlParams.append('mediaId', mediaId)
      }
      if (accountId) {
        urlParams.append('accountId', accountId)
      }
      if (opId) {
        urlParams.append('opId', opId)
      }
      if (!isEmpty(taskStatus)) {
        urlParams.append('taskStatus', taskStatus)
      }
      if (!isEmpty(accountStatus)) {
        urlParams.append('accountStatus', accountStatus)
      }
      if (!isEmpty(dataModel)) {
        urlParams.append('dataModel', dataModel)
      }
      if (!isEmpty(accountType)) {
        urlParams.append('accountType', accountType)
      }
      if (projectGroupOpId) {
        urlParams.append('projectGroupOpId', projectGroupOpId)
      }
      if (!isEmpty(whiteList)) {
        urlParams.append('whiteList', whiteList)
      }
      if (keyword) {
        urlParams.append('keyword', keyword)
      }
      if (order) {
        urlParams.append('order', order)
      }
      if (agentId) {
        urlParams.append('agentId', agentId)
      }
      if (sort) {
        urlParams.append('sort', sort)
      }
      if (len !== 0) {
        urlParams.append('effectAccountIdsStr', easySelectList.join(','))
      }
      const url = `${HOST_API}/api/ptom/tasksyc/downjoblist?${urlParams.toString()}`
      window.open(url)
    },
    searchFilterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    newJob(row) {
      this.modalMedia = ''
      this.modalAccount = ''
      this.accountData = []
      getSpiderMedia()
        .then((data) => {
          this.spiderMediaData = data
        })
        .catch((err) => {
          this.$Message.error(err)
        })
      this.newJobModal = true
    },
    changeActive() {
      if (this.alarmStatus === 1) {
        this.label1 = false
        this.label2 = false
        this.label3 = false
        this.finaceAlertUserStatus = false
      } else {
        this.label1 = true
        this.label2 = true
        this.label3 = true
        this.finaceAlertUserStatus = true
      }
    },
    openFinaceModal(row) {
      getSysMember()
        .then((data) => {
          this.finaceOperatorData = data
        })
        .catch((err) => {
          this.$Message.error(err)
        })
      this.mediaRow = row.mediaName
      this.accountRow = row.adAccount
      this.financeModal = true
      getFinanceEmailAlert()
        .then((data) => {
          if (data.alarmType && data.alarmStatus === 1) {
            this.alarmStatus = 1
            this.label1 = false
            this.label2 = false
            this.label3 = false
            this.alarm = data.alarmType.toString()
            this.finaceAlertUserStatus = false
            this.finaceAlertUser = data.idList
          } else {
            this.alarmStatus = 0
            this.finaceAlertUserStatus = true
            this.finaceAlertUser = []
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },
    handleMediaSelect(meta) {
      if (meta !== '') {
        this.modalMedia = meta
        adAccount({ mediaId: meta, authFlag: 1 })
          .then((data) => {
            this.accountData = data
          })
          .catch((err) => {
            this.$Message.error(err)
          })
      } else {
        this.modalAccount = ''
        this.accountData = []
      }
    },
    cancelNewJob() {
      this.newJobModal = false
    },
    cancelFinanceAlarm() {
      this.financeModal = false
    },
    confirmFinanceAlarm() {
      const params = Object.assign({}, this.app)
      if (this.alarmStatus !== '0') {
        params.alarmType = this.alarm
        if (this.finaceAlertUser.length !== 0) {
          params.opIds = this.finaceAlertUser.join(',')
        }
      }
      params.alarmStatus = this.alarmStatus - 0
      if (this.alarm && this.finaceAlertUser.length !== 0) {
        financeEmailAlertSet(params)
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              timeout(1000).then(() => {
                // this.jump()
                this.financeModal = false
              })
            } else {
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (!this.modalMedia) {
        this.$Message.warning('您未选择告警的人员')
        this.asyning = true
        timeout(0).then(() => {
          this.asyning = false
        })
      } else {
        timeout(600).then(() => {
          this.state = false
          this.$emit('on-select', this.currentRow)
        })
      }
    },
    confirmNewJob() {
      const params = Object.assign({}, this.app)
      params.accountId = this.modalAccount
      params.mediaId = this.modalMedia
      if (this.modalMedia && this.modalAccount) {
        addAdSpiderJob(params)
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              this.newJobModal = false
            } else {
              this.newJobModal = true
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (!this.modalMedia || !this.modalAccount) {
        if (!this.modalMedia) {
          this.$Message.warning('请选择媒体!')
        }
        if (this.modalMedia && !this.modalAccount) {
          this.$Message.warning('请选择账号!')
        }
        this.asyning = true
        timeout(0).then(() => {
          this.asyning = false
        })
      } else {
        timeout(600).then(() => {
          this.state = false
          this.$emit('on-select', this.currentRow)
        })
      }
    },
    handleAccountSelect(meta) {
      this.modalAccount = meta
    },
    jump() {
      this.$router.push({ name: 'joblist' })
    },
    filterSaveData(params) {
      this.pageIndex = 1
      this.filters = params
      params.pageIndex = this.pageIndex
      this.getData(params)
    },
    getCommonFilter(allData, localName, dataList) {
      const storage = getLocal(localName)
      if (storage) {
        const common = allData.filter((ret) => getLocal(localName).includes(ret.id))
        dataList[0].options = common
      }
      dataList[1].options = allData
    },
    proLoadData() {
      Promise.all([getSpiderMedia(), queryAgentList()])
        .then((data) => {
          let [mediaData, agentData] = data

          // 转换key值
          mediaData = mediaData.map((m) => ({
            ...m,
            id: m.mediaId,
            name: m.mediaName
          }))
          isArray(mediaData) && this.getCommonFilter(mediaData, 'commonMediaIds', this.mediaData)
          if (isArray(agentData)) {
            this.agentData = agentData.map((ret) => {
              return {
                id: ret.id,
                name: ret.agentName
              }
            })
          }
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    getData(filter) {
      if (this.sort === 'yestMoney') {
        this.sort = 'yest_money'
      } else if (this.sort === 'accountMoney') {
        this.sort = 'account_money'
      } else if (this.sort === 'lastThreeDaysConsume') {
        this.sort = 'last_three_days_consume'
      } else if (this.sort === 'lastMonthAmount') {
        this.sort = 'month_money'
      }
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter !== 'undefined') params = Object.assign(params, this.filters)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 请求数据
      this.spining = true
      getJobList(
        Object.assign(params, {
          selectJson: JSON.stringify(params)
        })
      ).then((data) => {
        this.spining = false
        if (data && typeof data !== 'symbol') {
          // eslint-disable-next-line
          const { total_number } = data.page.total
          this.sumdata = data.sumData
          const fmt_tofix = (num) => parseFloat(num.toFixed(2))
          this.jobList = data.page.datas.map((ret) => {
            if (ret.lastMonthAmount === null) {
              ret.lastMonthAmount = '—'
            } else {
              ret.lastMonthAmount = fmt_tofix(ret.lastMonthAmount)
            }
            if (ret.lastThreeDaysConsume === null) {
              ret.lastThreeDaysConsume = '—'
            } else {
              ret.lastThreeDaysConsume = fmt_tofix(ret.lastThreeDaysConsume)
            }
            if (ret.accountMoney === null) {
              ret.accountMoney = '—'
            } else {
              ret.accountMoney = fmt_tofix(ret.accountMoney)
            }
            if (ret.yestMoney === null) {
              ret.yestMoney = '—'
            } else {
              ret.yestMoney = fmt_tofix(ret.yestMoney)
            }

            if (ret.taskType === 1) {
              ret.taskType = '爬虫'
            } else if (ret.taskType === 2) {
              ret.taskType = '接口'
            }

            if (ret.taskStatus === 1) {
              ret.taskStatus = '启用'
              ret.taskSwitchStatus = 1
            } else if (ret.taskStatus === 0) {
              ret.taskStatus = '暂停'
              ret.taskSwitchStatus = 0
            }

            if (ret.accountStatus === 1) {
              ret.accountStatus = '启用'
            } else {
              ret.accountStatus = '禁用'
            }
            if (ret.dataModel === 1) {
              ret.dataModelText = '按名称1对1匹配'
            } else {
              ret.dataModelText = '汇总合计1条计划'
            }

            if (ret.white) {
              ret.white = '是'
            } else {
              ret.white = '否'
            }
            if (ret.lastSynTime === null) {
              ret.lastSynTime = ''
            } else {
              ret.lastSynTime = datetimeToSec(ret.lastSynTime)
            }
            if (ret.createTime === null) {
              ret.createTime = ''
            } else {
              ret.createTime = datetimeToSec(ret.createTime)
            }
            return ret
          })
          // eslint-disable-next-line
          this.total = data.page.total ? data.page.total : 0
          this.$nextTick(() => {
            this.$refs.tableRef && this.$refs.tableRef.doLayout()
          })
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      if (this.filters !== null && this.filters !== '' && typeof this.filters !== 'undefined') {
        this.filters.pageIndex = index
      }

      this.getData(this.filters)
    },
    changePageSize(size) {
      this.pageSize = size
      this.setLocalPage(size)
      if (this.filters !== null && this.filters !== '' && typeof this.filters !== 'undefined') {
        this.filters.pageIndex = 1
        this.filters.pageSize = size
      }

      this.getData(this.filters)
    },
    batchActions(type) {
      if ([1, 2, 3, 4].includes(type)) {
        this.$refs.tableRef.changeBetch(type)
      }

      if (type === 5) {
        this.$refs.tableRef.onDataSyncBatchAction()
      }

      if (type === 6) {
        this.$refs.tableRef.onAccountRechargeTransferAction()
      }
      if (type === 7) {
        this.$refs.tableRef.onToutiaoMediaAddAvatar()
      }
    },

    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    }
  },
  data() {
    return {
      tableColumns: [],
      rawTableCols: GROUP_TOUTIAO,
      tableHeight: 330,

      id: this.$router.currentRoute.query.id,
      adId: this.$router.currentRoute.query.adId,
      access: this.$store.state.accessAuth,
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      selectList: [], // 选中
      jobList: [], // 广告创意列表
      alarmStatus: '0',
      opids: '',
      sumdata: [], // 合计数据
      alarm: '1',
      label1: true,
      label2: true,
      label3: true,
      alertUser: '',
      newJobModal: false,
      financeModal: false,
      // 同步月数据form
      monthDataSyncForm: makeSyncFormItem(),
      modalMedia: '',
      modalAccount: '',
      alertUserStatus: true,
      // projectGroupData: [],
      AdvertPositionOriginalData: [],
      accountData: [],

      mediaData: [
        { label: '最近使用', options: [] },
        { label: '', options: [] }
      ],
      spiderMediaData: [], // 爬虫可用的开启媒体
      mediaList: '',
      agentData: [],
      accountList: '',
      groupData: [
        { label: '最近使用', options: [] },
        { label: '', options: [] }
      ],
      finaceOperatorData: [
        { label: '最近使用', options: [] },
        { label: '', options: [] }
      ],
      finaceAlertUser: '',
      finaceAlertUserStatus: true,
      columns: [],
      states: []
    }
  },
  created() {},
  activated() {
    if (this.params) {
      this.proLoadData()
    } else if (this.editMap) {
      this.editLoad = false // 关闭时间更新请求
      this.betchCond() // 账号跳转
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  padding: 10px 15px 0;

  .c-control {
    background-color: #fff;
    margin-bottom: 8px;
    ::v-deep .operate-btns {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .pager {
    padding: 5px 0;
    text-align: right;
  }
}
</style>

<style lang="scss">
.sync-form-modal {
  .sync-form {
    .error-info {
      margin-top: 6px;
      line-height: 20px;
      max-height: 200px;
      overflow: auto;
    }
  }
}
</style>
